import React, { Fragment } from "react"
import PropTypes from "prop-types"

// material-ui
import withStyles from "@material-ui/core/styles/withStyles"

import ImageLoading from "../ImageLoading"
import styles from "./styles"

class OptimizedImage extends React.PureComponent {
    state = {
        loaded: false,
    }

    onLoad = () => this.setState({ loaded: true })

    render () {
        const {
            classes,
            src,
            onLoad,
            ...rest,
        } = this.props

        const { loaded } = this.state

        return (
            <Fragment>
                {loaded ? 
                    <div
                        className={classes.image}
                        style={{
                            background: `url(${src}) center center / contain no-repeat`,
                            opacity: loaded ? 1 : 0,
                        }}
                        {...rest}
                    />
                    : <ImageLoading />
                }
                <img
                    src={src}
                    alt="hidden"
                    className={classes.hidden}
                    onLoad={this.onLoad}
                />
            </Fragment>
        )
    }
}

OptimizedImage.propTypes = {
    src: PropTypes.string.isRequired,
    onLoad: PropTypes.func,
}

OptimizedImage.defaultProps = {
    onLoad: null,
}

export default withStyles(styles)(OptimizedImage)



// WEBPACK FOOTER //
// ./src/lib/components/OptimizedImage/index.js